import type { GetFileURLDTOType, GetFileURLResponseType } from '@/features/files/types'
import type {
  CheckDeliverableImportationResponseType,
  CheckFileImportationDTOType,
  DeleteFileDTOType,
  DeleteFileResponseType,
} from '@/features/sessions/types'
import fetchClient from '@/lib/fetch'

export async function checkFileImportationMutation(
  data: CheckFileImportationDTOType,
): Promise<CheckDeliverableImportationResponseType> {
  return fetchClient(`/v1/files/${data.fileId}/check-imported`, {
    method: 'GET',
  })
}

export async function deleteFileMutation(data: DeleteFileDTOType): Promise<DeleteFileResponseType> {
  return fetchClient(`/v1/files/${data.fileId}`, {
    method: 'DELETE',
  })
}

export async function getFileURL(data: GetFileURLDTOType): Promise<GetFileURLResponseType> {
  return fetchClient(`/v1/files/${data.fileId}/users/${data.userId}/url`, {
    method: 'GET',
  })
}
